export default __webpack_public_path__ + "static/media/navbar-vertical.8de69786.png";